import React, { useEffect } from "react";
import styles from "./contentcard.module.css";
import CandidateFlow from "../../components/CandidateFlow";
import { useSelector } from "react-redux";
import { RootState, useAppDispatch } from "../../store";
import { setProcurementFilters } from "../../store/filtersSlice";
import WorkflowFlowchart from "../WorkflowFlowchart";

type ContentCardProps = {
  title: string;
  imageUrl?: string;
  subTitle?: string;
  description?: string;
};

const ContentCard = ({
  title,
  imageUrl,
  subTitle,
  description,
}: ContentCardProps) => {
  const dispatch = useAppDispatch();
  const currentAgent = useSelector(
    (state: RootState) => state.agents.currentAgent
  );
  const agentId = currentAgent?.id.toString();
  const { procurementFilters } = useSelector(
    (state: RootState) => state.filters,
  );
  const { loading } = useSelector((state: RootState) => state.user);

  // Handle direct navigation to agent 20 - default to reviewer mode
  useEffect(() => {
    if (agentId === "20" && !procurementFilters.procurementType) {
      dispatch(
        setProcurementFilters({
          procurementType: "reviewer",
        }),
      );
    }
  }, [agentId, dispatch, procurementFilters.procurementType]);

  return (
    <div className={styles.contentCard}>
      <div>
        {/* {(agentId === "18" || agentId === "106" || agentId === "7") && (
          <div className={styles.betaBadge}>
            <span style={{ fontSize: 14, fontWeight: 600 }}>
              {" "}
              Beta for user feedback{" "}
            </span>
          </div>
        )} */}
        {imageUrl && (
          <>
            <img
              src={imageUrl}
              alt="G42 logo"
              width="80"
              style={{ marginTop: "30px" }}
            />
            <div className={styles.logoTriangle} />
          </>
        )}
      </div>
      <h1>{title}</h1>
      {subTitle && <h3>{subTitle}</h3>}
      {description && <p>{description}</p>}
      {agentId === "11" && <WorkflowFlowchart />}
      <CandidateFlow agentId={agentId} />
      <div className={styles.logoTriangle} />
    </div>
  );
};

export default ContentCard;
